export default "__VITE_ASSET__Dg3Omtt$__"